import { Injectable } from '@angular/core';
import { Observable, Subject, interval } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DgTimerService {
  private worker: Worker;
  constructor() {
    if (typeof Worker !== 'undefined') {
      // Create a new
      this.worker = new Worker(
        new URL('src/app/worker/dg-timer.worker.ts', import.meta.url)
      );
    } else {
      // Web workers are not supported in this environment.
      // You should add a fallback so that your program still executes correctly.
    }
  }

  getTimerObs(
    timeLeft: number,
    intervalSec: number = 1,
    id: string
  ): Observable<number> {
    /*  const subject = new Subject<number>();
    this.worker.postMessage({
      action: 1,
      timeLeft: timeLeft,
      intervalSec: intervalSec,
      id: id,
    });
    this.worker.onmessage = ({ data }) => {
      if (data?.id === id) {
        subject.next(data?.time);
      }
    }; */
    const dTime = new Date();
    dTime.setSeconds(dTime.getSeconds() + timeLeft + 1); //added 1 sec bcs Math.floor start value - 1 sec
    const timerObs = interval(1000).pipe(
      filter((timeConsume: number) => timeConsume % intervalSec === 0),
      map(() => {
        return dTime.getTime() - new Date().getTime() > -1
          ? Math.floor((dTime.getTime() - new Date().getTime()) / 1000)
          : 0;
      })
    );

    return timerObs;
  }
  terminateAllTimer(): void {
    this.worker.postMessage({
      action: -1,
    });
  }
  terminateTimerById(id): void {
    this.worker.postMessage({
      action: 0,
      id: id,
    });
  }
}
